module.exports = __webpack_public_path__ + "img/tcv_stopped.0ef8cabb.svg";